<template>
  <div>
    <div class="text-center">
      <vs-button class="m-3" v-show="mapIsLock && !readonly" @click="mapIsLock=false">فعال سازی نقشه</vs-button>
    </div>
    <div id="location-map" style="height: 200px;margin-right:5px"></div>
  </div>

</template>

<script>
  import {map, tileLayer} from 'leaflet';
  import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
  import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
  import {GeoSearchControl, OpenStreetMapProvider} from 'leaflet-geosearch';

  export default {
    name: "SelectLocation",
    mounted() {
      if (this.editLock) {
        this.mapIsLock = !!this.default; // lock map in edit mode
      }
      var map = L.map('location-map', {fullscreenControl: true});
      L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
        .addTo(map);


      if (!this.readonly) {
        const provider = new OpenStreetMapProvider({
          params: {
            countrycodes: 'ir',
            city: 'تهران',
            state: 'تهران',
            //  : true,
            // viewbox:'35.733659,51.376373,35.739853,51.601999'
            //   // key : 'AIzaSyAoVQoW5S1wa-WR-vfTOMmuKJp9r9RSUQk'
          },
        });

        const searchControl = new GeoSearchControl({
          provider: provider,
          autoComplete: true,
          style: 'button',
          showMarker: false,
          searchLabel: 'جستجوی محله'
        });
        map.addControl(searchControl);

        map.on('click', (e) => {
          if (!this.mapIsLock) {
            if (this.marker) {
              this.marker.setLatLng(e.latlng);
            } else {
              this.marker = L.marker(e.latlng);
              this.marker.addTo(map)
            }
            this.markerLatLng = {
              latitude: e.latlng.lat,
              longitude: e.latlng.lng,
            }
          }
        });
        // map.on('geosearch/showlocation',  (e) => {
        //   console.log(e.location)
        //   this.markerLatLng = {
        //     latitude: e.location.x,
        //     longitude: e.location.y,
        //   }
        // });
      }

      if (this.default) {
        this.student = Object.assign({}, this.data)
        let latlng = new L.latLng(this.default.latitude, this.default.longitude);
        this.marker = L.marker(latlng)
        this.marker.addTo(map)
        this.markerLatLng = {
          latitude: latlng.lat,
          longitude: latlng.lng,
        }
        map.setView([latlng.lat, latlng.lng], 14);
      } else {
        map.setView([35.715298, 51.404343], 12); //tehran location
      }

      this.map = map
    },
    data() {
      return {
        map: null,
        mapIsLock: this.editLock,
        marker: '',
        markerLatLng: {
          latitude: '',
          longitude: ''
        },
      }
    },
    watch: {
      markerLatLng(val) {
        this.$emit('change', val)
      },
      default(val) {
        if (this.marker && val) {
          if (Object.keys(val).length) {
            const latlng = new L.latLng(val.latitude, val.longitude);
            this.map.setView([val.latitude, val.longitude], 14);
            this.marker.setLatLng(latlng);
          }
        }
      }
    },
    methods: {},
    props: {
      default: {
        type: [Object, String],
      },
      editLock: {
        type: Boolean,
        default: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      mapId: {
        type: String,
        default: 'location-map'
      },
    }
  }
</script>

<style scoped>

</style>
